import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { ShiftOptions } from 'models/ICattlesData'
import { IMilkingProcessGraph } from 'models/MilkingProcess'
import MilkingProcessService from 'services/milkingProcessService'

export const useMilkingProcessGraph = (
	startDate: number,
	endDate: number,
	shiftPeriod: ShiftOptions[] | 'all',
	parlorId?: number[] | 'all',
	dayDate?: string,
) => {
	const { data, refetch, isError, isLoading } = useQuery<
		IMilkingProcessGraph,
		AxiosError
	>({
		queryKey: [
			'milking-process-graph',
			startDate,
			endDate,
			shiftPeriod,
			parlorId,
			dayDate,
		],
		queryFn: async () => {
			const response = await MilkingProcessService.getMilkingProcessGraph(
				startDate,
				endDate,
				shiftPeriod,
				parlorId,
				dayDate,
			)
			return response
		},
		staleTime: 50000,
		retry: 3,
	})

	return {
		data,
		isLoading,
		isError,
		refetch,
	}
}
